import React, { Component } from "react";
import "./Logo.css";
import PropTypes from "prop-types";
import sopiaLogo from '../../images/icons/logo.png'

export default class Logo extends Component {

    render() {
        const Container = this.props.link ? "a" : "span";
        return (
            <Container className="Logo" href="/">
                <img src={sopiaLogo} alt="logo" className="header-logo" style={this.props.black ? { filter: 'brightness(0)' } : {}}></img>
            </Container>
        );
    }

}

Logo.propTypes = {
    link: PropTypes.bool
}